import { render, staticRenderFns } from "./TlmCheckoutMenus.vue?vue&type=template&id=1887d6e2"
import script from "./TlmCheckoutMenus.vue?vue&type=script&lang=js"
export * from "./TlmCheckoutMenus.vue?vue&type=script&lang=js"
import style0 from "./TlmCheckoutMenus.vue?vue&type=style&index=0&id=1887d6e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TlmCheckoutMenu: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmCheckout/TlmCheckoutMenu.vue').default})
